const { REACT_APP_WOWNET_CONTENTS: CONTENT } = process.env

export const WOWNET_CONTENT = {
  footerMini: `${CONTENT}/Footer`,
  footerMaxBox: `${CONTENT}/FooterProduct`,
  header: `${CONTENT}/Header`,
  aside: `${CONTENT}/Aside`,
  link: `${CONTENT}/Link`,
}
